import React, { useEffect, useRef, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteDrink,
  getDrinks,
  getDrinksError,
  getDrinksStatus,
  selectAllDrinks,
  getDrinksSuccess,
  updateStatus,
} from "../../../features/drinkSlice";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import ProductCard from "../../../components/card";
import NoData from "../../../components/noData";
import AppBarSearch from "../../../global/appBarSearch";
import { Box, Grid } from "@mui/material";
import AlertDialog from "../../../components/alertDialog";
import { toast } from "react-toastify";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { useTranslation } from "react-i18next";
import { CardField, CardStatus } from "../../../components/cardMeta";

const Drink = () => {
  const { t } = useTranslation();
  const {restaurantId, currency} = useRestaurant();
  const [filteredDrinks, setFilteredDrinks] = useState([]);
  const dispatch = useDispatch();
  const status = useSelector(getDrinksStatus);
  const error = useSelector(getDrinksError);
  const drinks = useSelector(selectAllDrinks);
  const success = useSelector(getDrinksSuccess);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [cardId, setCardId] = useState(null);
  const handleClickOpen = (cardId) => {
    setOpen(true);
    setCardId(cardId);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("add");
  };
  const handleModify = (data) => {
    navigate("modify", { state: { drink: data } });
  };
  const hasFetchedInMountRef = useRef(false);
  const lastFetchedRestaurantRef = useRef(restaurantId);
  useEffect(() => {
    const restaurantChanged =
      hasFetchedInMountRef.current &&
      lastFetchedRestaurantRef.current !== restaurantId;
    const alreadyLoaded = drinks.length > 0 && status === "fetchData";
    if (restaurantChanged || !alreadyLoaded) {
      dispatch(getDrinks(restaurantId));
    }
    hasFetchedInMountRef.current = true;
    lastFetchedRestaurantRef.current = restaurantId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "fetchData") {
      setFilteredDrinks(
        drinks?.filter((dish) =>
          dish.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [drinks, search, status]);

  useEffect(() => {
    if (status === "deleteSuccess") {
      toast.success(success);
      setFilteredDrinks((prev) => prev.filter((item) => item._id !== cardId));
      dispatch(updateStatus());
    } else if (status === "deleteError") {
      toast.error(error);
    }
  }, [status, error, success, dispatch, cardId]);
  return (
    <div className="main-application">
      <CssBaseline />
      <AppBarSearch
        handleSubmit={handleSubmit}
        handleSearch={(e) => setSearch(e.target.value)}
        title={t("pages.myDrinks")}
        buttonTitle={t("actions.addDrink")}
      />
      <main>
        <Box maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={2}>
            {status === "loadingFetchData" ? (
              <Loading />
            ) : status === "fetchError" ? (
              <Error>{error}</Error>
            ) : (
              <>
                {filteredDrinks && filteredDrinks.length > 0 ? (
                  filteredDrinks.map((card) => (
                    <ProductCard
                      key={card._id}
                      data={card}
                      handleModify={() => handleModify(card)}
                      content={
                        <>
                          <CardField label={t("fields.price")}>
                            {card.price ?? 0} {currency}
                          </CardField>
                          <CardStatus
                            outOfStock={card.outOfStock}
                            visible={card.visible}
                          />
                        </>
                      }
                      handleClickOpen={() => handleClickOpen(card._id)}
                    />
                  ))
                ) : (
                  <NoData />
                )}
                <AlertDialog
                  handleClose={() => setOpen(false)}
                  open={open}
                  name={"boisson"}
                  cardId={cardId}
                  deleteData={() =>
                    dispatch(deleteDrink({ drinkId: cardId, restaurantId }))
                  }
                />
              </>
            )}
          </Grid>
        </Box>
      </main>
    </div>
  );
};

export default Drink;
